// ~ Функція очищення розмітки
export default function clearDOM() {
  document.querySelector('.gallery').innerHTML = '';
}
